// Редовият модел на „Натовареност" — един ред = един отрязък от времето.
//
// Етикетът се строи с общия `periodLabelOf` на „Продажби по периоди": същите
// думи („13:00 – 13:59", „Понеделник", „29.06.2026") за същия ключ. Сборовете
// са по ПОКАЗАНИТЕ редове — кутийките и графиката следват търсачката, както
// таблицата и Excel. В режим „слято" една резервация стои в един-единствен
// отрязък, така че сборът е и брой резервации за периода.

import type {
  ReservationOccupancyRow,
  ReservationStatusCounts,
} from "../../../../api/reportsReservations";
import type {
  SalesByPeriodsMode,
  SalesByPeriodsUnit,
} from "../../../../api/reportsSalesByPeriods";
import {
  periodLabelOf,
  type PeriodLabels,
} from "../salesByPeriods/salesByPeriodsMath";
import { emptyStatusCounts } from "./reservationReportFormat";

export type OccupancyPeriodRow = PeriodLabels &
  ReservationStatusCounts & {
    key: string;
    guests: number;
    avgPlannedMinutes: number | null;
    avgSeatedMinutes: number | null;
  };

export type OccupancyTotals = ReservationStatusCounts & {
  rows: number;
  guests: number;
  /** Резервации на отрязък — „средно на час/ден/месец". */
  perRow: number | null;
};

export const buildOccupancyRows = (
  rows: ReservationOccupancyRow[],
  mode: SalesByPeriodsMode,
  unit: SalesByPeriodsUnit,
  language: string,
): OccupancyPeriodRow[] =>
  rows.map((row) => ({
    key: row.key,
    ...periodLabelOf(row, mode, unit, language),
    reservations: row.reservations,
    upcoming: row.upcoming,
    seated: row.seated,
    completed: row.completed,
    cancelled: row.cancelled,
    expired: row.expired,
    guests: row.guests,
    avgPlannedMinutes: row.avg_planned_minutes,
    avgSeatedMinutes: row.avg_seated_minutes,
  }));

export const totalsOfOccupancyRows = (rows: readonly OccupancyPeriodRow[]): OccupancyTotals => {
  const counts = emptyStatusCounts();
  let guests = 0;
  for (const row of rows) {
    counts.reservations += row.reservations;
    counts.upcoming += row.upcoming;
    counts.seated += row.seated;
    counts.completed += row.completed;
    counts.cancelled += row.cancelled;
    counts.expired += row.expired;
    guests += row.guests;
  }
  return {
    ...counts,
    rows: rows.length,
    guests,
    perRow: rows.length > 0 ? counts.reservations / rows.length : null,
  };
};
